/* Copyright (c) 2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, Spacer, Text, theme } from "@nordcloud/gnui";
import { FilterHeader, getSelectedMode, Mode } from "~/components";
import { isNotEmpty, noop } from "~/tools";
import { NumberRangeInput } from "~/views/resources_v2/components/Filters/NumberRangeInput";

export type FiltersProp = {
  lifeSpanFrom?: number;
  lifeSpanTo?: number;
  lifeSpanExclude?: boolean;
};

type Props = {
  filters: FiltersProp;
  updateFilters: (input: FiltersProp) => void;
  isExcludeSelected?: boolean;
  onModeChange?: (mode: Mode) => void;
};

export function LifeSpanInput({
  filters,
  updateFilters,
  isExcludeSelected,
  onModeChange,
}: Props) {
  return (
    <>
      <FilterHeader
        allowModeChange
        defaultMode={getSelectedMode(isExcludeSelected)}
        onSetSearch={noop}
        onModeChange={onModeChange}
      />
      <Spacer height={theme.spacing.spacing04} />
      <FlexContainer marginTop={theme.spacing.spacing04}>
        <Text>Specify the life span of the resource activity</Text>
      </FlexContainer>
      <div style={{ whiteSpace: "nowrap" }}>
        <div style={{ display: "inline-block" }}>
          <NumberRangeInput
            from={filters.lifeSpanFrom}
            to={filters.lifeSpanTo}
            onChangeFrom={(value: string) =>
              updateFilters({
                lifeSpanFrom: getNumberFilterValue(value),
                lifeSpanTo: filters.lifeSpanTo,
              })
            }
            onChangeTo={(value: string) =>
              updateFilters({
                lifeSpanFrom: filters.lifeSpanFrom,
                lifeSpanTo: getNumberFilterValue(value),
              })
            }
          />
        </div>
        <span>days</span>
      </div>
    </>
  );
}

function getNumberFilterValue(value: string): number | undefined {
  return isNotEmpty(value) ? Number(value) : undefined;
}
